import { useTranslation } from 'react-i18next';
import { Steps, Tooltip } from 'antd';
import type { TArrivalInformation } from 'api/swagger';
import styles from './trip-arrival-information.module.scss';
import type { ITripArrivalInformationProps } from './types';
import { buildStepTitle, prepareArrivalInformationChunks } from './utils';

export const TripArrivalInformation: React.FC<ITripArrivalInformationProps> = (props) => {
  const { arrivalInformation = [] } = props;
  const { t } = useTranslation();

  if (!arrivalInformation.length) return null;

  const arrivalInformationChunks = prepareArrivalInformationChunks(arrivalInformation);

  const renderCargoIds = (cargoIds: string[]) => {
    if (!cargoIds || cargoIds.length === 0) return null;

    const visibleCargos = cargoIds.slice(0, 3);
    const hiddenCargos = cargoIds.slice(3);

    return (
      <div className={styles.cargoIds}>
        {visibleCargos.join(', ')}
        {hiddenCargos.length > 0 && (
          <>
            {', '}
            <Tooltip title={hiddenCargos.join(', ')}>
              <span style={{ cursor: 'pointer' }}>...</span>
            </Tooltip>
          </>
        )}
      </div>
    );
  };

  const buildDescription = (info: TArrivalInformation) => {
    const cargoIds = info.relatedCompositeCargoIds;

    return (
      <>
        {renderCargoIds(cargoIds)}
        {!info.done && <div>{info.estimatedTime}</div>}
      </>
    );
  };

  return (
    <>
      <div className={styles.header}>
        <h3>{t('common:estimated_arrival_information')}</h3>
      </div>

      {arrivalInformationChunks.map((infoChunk, index) => {
        return (
          <Steps
            key={index}
            className={styles.tripSteps}
            direction='horizontal'
            items={infoChunk.map((info) => ({
              title: buildStepTitle(info),
              description: buildDescription(info),
              status: info.done ? 'finish' : 'wait',
            }))}
            progressDot
          />
        );
      })}
    </>
  );
};
